<template>
    <div>
        <div class="rules__header --search-page">
            <div class="text-bold rules__header-wrapper">
                <div class="rules__header-left">
                    <template v-if="!isLoadItems || ruleTypeError">
                        <div class="text-size-ml text-bold search-result">
                            <span class="i i-search2 mr8"></span>Результаты поиска «<span class="query" @click="openSearchField">{{ searchStr }}</span>»
                        </div>
                    </template>
                </div>
                <div class="rules__header-right">
                    <search-filters></search-filters>
                    <div class="close-search" @click="back(true)"></div>
                </div>
            </div>
        </div>
        <div class="content moderator-rules content__search-page">
            <div v-if="isLoadItems && !ruleTypeError" class="preloader-page">
                <div class="preloader"></div>
            </div>
            <div v-if="(!isLoadItems && $store.getters['rules/getItems'].length === 0) || ruleTypeError" class="nothing-block">
                <div class="nothing-block__wrapper">
                    <svg class="big-icon">
                        <use xlink:href="@/assets/img/big-icons-sprite.svg#emoji-nothing"></use>
                    </svg>
                    <div class="text-size-l text-color-grey mt16">По запросу «{{ searchStr }}» ничего не найдено</div>
                    <div class="rules__btn mt16" @click="openSearchField">
                        <span class="elem">Изменить запрос</span>
                    </div>
                </div>
            </div>
            <div class="container" v-else>
                <div class="container__full container-scroll container__right container__search-page" :class="{'container__rule-detail-page': true}">
                    <rules-list></rules-list>
                    <transition name="slide">
                        <rule-detail v-if="popups.ruleDetail.show" :show="popups.ruleDetail.show"/>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import SearchFilters from '../forms/SearchFilters.vue';
import RulesList from '@/components/moderator/Rules/SearchList.vue';
import RuleDetail from '@/components/modal/rules/RuleDetail.vue';

export default {
    metaInfo() {
        return {
            title: 'РЕГЛАМЕНТЫ И ПРАВИЛА',
            titleTemplate: this.$store.state.options.titleTemplate
        }
    },
    name: "Rules",
    components: {
        SearchFilters,
        RulesList,
        RuleDetail
    },
    data() {
        return {
            ruleType: 0,
            search: '',
            filterType: { value: 0 },
            isChangeRule: false
        };
    },
    computed: {
        ...mapState({
            popups: state => state.popups.items,
            isLoadItems: state => state.rules.isLoadItems,
            searchStr: state => state.rules.searchStr,
            searchInputValue: state => state.rules.searchInputValue,
            ruleTypeError: state => state.rules.ruleTypeError
        }),
        ...mapGetters('rules', ['getItems']),
        is404() {
            return this.$route.name === 'page404' || (!this.isLoadItems && this.getItems.length === 0);
        }
    },
    methods: {
        openSearchField() {
            this.$store.commit('rules/setSearchInputValue', this.searchStr);
            this.$store.commit('rules/openSearchField', true);
            this.$nextTick(() => document.getElementById('searchFieldInput').focus());
        },
        back() {
            this.$store.commit('rules/setIsSearch', false);
            this.$store.commit('popups/close', { name: this.popups.ruleDetail.name });
        }
    },
    mounted() {
        document.addEventListener('keyup', this.keyUp);
    },
    beforeDestroy() {
        document.removeEventListener('keyup', this.keyUp);
    }
}
</script>